import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { MarkdownElement } from "@ploy-ui/core";
import ContentListItem from "../../ContentListItem";
import { Collapse } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
export var ContentVisibility;
(function (ContentVisibility) {
    ContentVisibility["Expanded"] = "Expanded";
    ContentVisibility["Opened"] = "Opened";
    ContentVisibility["Always"] = "Always";
})(ContentVisibility || (ContentVisibility = {}));
export function TextListItem(props) {
    const { primary, secondary, tertiary, content, contentVisibility = ContentVisibility.Always, hideDivider, onSelect, iconClass, selected } = props;
    const markdownTypographProps = useMemo(() => {
        return {
            component: MarkdownElement,
            inline: true
        };
    }, []);
    try {
        return (_jsxs(_Fragment, { children: [_jsx(ContentListItem, { button: (!!content &&
                        contentVisibility !== ContentVisibility.Always), iconClass: iconClass, onClick: content ? onSelect : undefined, hideChevron: !content || contentVisibility === ContentVisibility.Always, chevronIcon: content && contentVisibility === ContentVisibility.Expanded ? (selected ? (_jsx(ExpandLessIcon, {})) : (_jsx(ExpandMoreIcon, {}))) : undefined, hideDivider: hideDivider, primary: primary, secondary: secondary, tertiary: tertiary, primaryTypographyProps: markdownTypographProps, secondaryTypographyProps: markdownTypographProps, tertiaryTypographyProps: markdownTypographProps }), content && contentVisibility === ContentVisibility.Expanded && (_jsx(Collapse, { in: selected, timeout: "auto", children: _jsx(MarkdownElement, { text: content }) })), content && contentVisibility === ContentVisibility.Always && (_jsx(MarkdownElement, { text: content }))] }));
    }
    catch {
        return null;
    }
}
//# sourceMappingURL=TextListItem.js.map